import { Dispatch } from "@reduxjs/toolkit";
import handleChatWidgetOpen from "./handleChatWidgetOpen";
import emitAiChatInitiatedEvent from "./emitAiChatInitiatedEvent";
import {
  toggleShowWidgetState,
  setOpenAmberCopilot,
} from "@Pages/PropertyPage/components/ZendeskChat/ChatBotReducer";
import { FLOATING_BUTTON_ENTRY_POINTS } from "constants/index";

interface OpenChatWidgetParams {
  dispatch: Dispatch;
  isMobile: boolean;
  isDesktop: boolean;
  isAmberCopilotEnabled: boolean;
  entryPoint?: string;
}

const openChatWidget = ({
  dispatch,
  isMobile,
  isDesktop,
  isAmberCopilotEnabled,
  entryPoint = FLOATING_BUTTON_ENTRY_POINTS.PAGE_BUTTON,
}: OpenChatWidgetParams) => {
  if (isAmberCopilotEnabled) {
    dispatch(setOpenAmberCopilot(true));
    emitAiChatInitiatedEvent(entryPoint);
  } else {
    handleChatWidgetOpen(isMobile);
    dispatch(toggleShowWidgetState(isDesktop));
  }
};

export default openChatWidget;
